import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ParamModel } from "app/model/cliente/param.model";
import ParamCompany from "app/model/cliente/ParamCompany.model";

import { ParamsService } from "../../../service/cliente/params/params.service";

@Component({
  selector: "app-param-type-dialog",
  templateUrl: "./param-type-dialog.component.html",
  styleUrls: ["./param-type-dialog.component.scss"],
})
export class ParamTypeDialogComponent implements OnInit {
  public paramCompanyForm: FormGroup;
  public paramForm: FormGroup;
  isLoading = true;
  groupSelected;
  typeSelected;
  typesGroup: any[] = [];
  typeSelectedName: string;

  formValue: ParamCompany = {
    id: null,
    paramId: this.data.paramToEdit.id,
    companyId: this.data.companyIdSelected,
    value: null,
  };

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ParamTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      groupSelected: any;
      isEditParam: boolean;
      paramToEdit: ParamModel;
      companyIdSelected: number;
      companyName: string;
      mode: "PARAM_EDIT" | "PARAM_COMPANY_EDIT";
    },
    private paramService: ParamsService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.groupSelected = this.data.groupSelected;
    this.paramCompanyForm = this.fb.group({
      id: [this.formValue.id],
      companyId: [this.formValue.companyId, Validators.required],
      paramId: [this.formValue.paramId, Validators.required],
      value: [this.formValue.value, Validators.required],
    });

    this.paramForm = this.fb.group({
      id: [this.data.paramToEdit.id],
      name: [this.data.paramToEdit.name],
      description: [this.data.paramToEdit.description],
      defaultValue: [
        this.data.paramToEdit.paramTypeId != 5
          ? this.data.paramToEdit.defaultValue
          : this.data.paramToEdit.defaultValue === "true",
      ],
      paramGroupId: [this.data.paramToEdit.paramGroupId],
      paramTypeId: [this.data.paramToEdit.paramTypeId],
    });

    this.paramService.getAllParamTypes().subscribe(
      (data) => {
        this.isLoading = false;
        this.typesGroup = data;
        this.typeSelectedName = this.typesGroup.find(
          (el) => el.id === this.data.paramToEdit.paramTypeId
        ).name;

        if (this.data.isEditParam) {
          // if (this.data.paramToEdit.paramTypeId === 5) {
          //   this.data.paramToEdit.defaultValue = String(
          //     this.data.paramToEdit.defaultValue === "true"
          //     );
          //     this.paramForm.get('defaultValue').setValue(this.data.paramToEdit.defaultValue);
          //     this.paramForm.updateValueAndValidity()
          // }
          // this.data.paramToEdit.defaultValue = "false"
          console.log(
            this.data.paramToEdit.defaultValue,
            Boolean(this.data.paramToEdit.defaultValue === "true")
          );

          // this.paramForm
          //   .get("paramTypeId")
          //   .setValue(
          //     this.typesGroup.find(
          //       (el) => el.id === this.data.paramToEdit.paramTypeId
          //     )
          //   );
        }
      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );

    switch (this.data.mode) {
      case "PARAM_COMPANY_EDIT":
        this.findParamCompany();
        break;

      case "PARAM_EDIT":
        this.findParamCompany();
        break;
      default:
        break;
    }
  }

  // fillParam() {
  //   this.paramForm.setValue({
  //   });
  // }

  findParamCompany() {
    this.paramService
      .findParamCompanyByCompanyIdAndParamId(
        this.data.companyIdSelected,
        this.data.paramToEdit.id
      )
      .subscribe((pCompany: ParamCompany) => {
        if (pCompany == null) {
          return;
        }
        this.paramCompanyForm.setValue({
          id: pCompany.id,
          companyId: pCompany.companyId,
          paramId: pCompany.paramId,
          value:
            this.data.paramToEdit.paramTypeId != 5
              ? pCompany.value
              : pCompany.value === "true",
        });
      });
  }

  onSelectionChange() {
    // console.log(this.paramCompanyForm.get('type'));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveParamCompany() {
    console.log(this.paramCompanyForm.value);
    if (this.paramCompanyForm.invalid) {
      this.paramCompanyForm.markAsTouched();
      return this.openSnackBar("Formulário com erros", true);
    }

    this.paramService.saveParamValue(this.paramCompanyForm.value).subscribe(
      (data) => {
        this.openSnackBar("Valor do parâmetro salvo com sucesso", false);
        console.log(data);
      },
      (err) => {
        this.openSnackBar("Erro ao salvar o valor do parâmetro", true);
        // this.dialogRef.close();
        console.error(err);
      }
    );
  }

  saveParam() {
    console.log("this.paramForm.value);---", this.paramForm.value);
    console.log("this.formValue);---", this.formValue);
    if (this.paramForm.invalid) {
      this.paramForm.markAsTouched();
      return this.openSnackBar("Formulário com erros", true);
    }

    this.paramService.saveParam(this.paramForm.value).subscribe(
      (data) => {
        this.openSnackBar("Parâmetro salvo com sucesso", false);
        console.log(data);
        this.dialogRef.close("PARAM_SAVED");
      },
      (err) => {
        console.error(err);
        this.openSnackBar("Erro ao salvar o parâmetro", true);
      }
    );
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/param-type-dialog/param-type-dialog.component.ts